// import logo from './logo.svg';
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import PageNotFound from "./pages/PageNotFound";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/footer/Footer";

import Inicio from "./pages/Inicio";
import Somos from "./pages/Somos";
import Servicios from "./pages/Servicios";
import Galeria from "./pages/Galeria";
import Catalogo from "./pages/Catalogo";
import Contacto from "./pages/Contacto";
import { Toaster } from "sonner";

function App() {
  return (
    <Router>
      <Toaster position="top-right" richColors />
      <Navbar />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/somos" element={<Somos />} />
        <Route path="/servicios" element={<Servicios />} />
        <Route path="/galeria" element={<Galeria />} />
        {/* <Route path="/catalogo" element={<Catalogo />} /> */}
        <Route path="/contacto" element={<Contacto />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
